import React, { useState, useEffect } from "react";
import withdrawAPI from "../../API/withdrawAPI";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const VND = new Intl.NumberFormat("vi-VN", {
  style: "currency",
  currency: "VND",
});

function HistoryWithdraw() {
  const [historyWitdraw, setHistoryWitdraw] = useState([]);

  useEffect(() => {
    try {
      const fetchGetHistoryWithdraw = async () => {
        const result = await withdrawAPI.getHistoryWitdraw();
        // console.log(result);

        if (result.status === "ok") {
          setHistoryWitdraw(result.data);
        } else if (result.status === false) {
          toast.error(result.msg, { theme: "light" });
        }
      };

      fetchGetHistoryWithdraw();
    } catch (error) {
      return toast.error("Có lỗi xảy ra", { theme: "light" });
    }
  }, []);

  return (
    <div>
      {historyWitdraw.length > 0 ? (
        <table className="table table-bordered rounded table-hover">
          <thead className="text-center" style={{ backgroundColor: "#e8f0fc" }}>
            <th>Thời gian đề xuất</th>
            <th>Loại hình giao dịch</th>
            <th>Số tiền nhận thực tế</th>
            <th>Ghi chú phê duyệt</th>
            <th>Trạng thái giao dịch</th>
            <th>Thao tác</th>
          </thead>
          <tbody>
            {historyWitdraw.map((item, i) => {
              return (
                <tr key={i} className="text-center">
                  <td>{item.create_at}</td>
                  <td>{item.type}</td>
                  <td>{VND.format(item.amount)}</td>
                  <td>{item.id_txn}</td>
                  <td>{item.descriptions}</td>
                  <td>Chi tiết</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <>
          <table className="table table-bordered rounded">
            <thead
              className="text-center"
              style={{ backgroundColor: "#e8f0fc" }}
            >
              <th>Thời gian đề xuất</th>
              <th>Loại hình giao dịch</th>
              <th>Số tiền nhận thực tế</th>
              <th>Ghi chú phê duyệt</th>
              <th>Trạng thái giao dịch</th>
              <th>Thao tác</th>
            </thead>
          </table>
          <span className="d-flex align-items-center justify-content-center py-2">
            Không có dữ liệu
          </span>
        </>
      )}

      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default HistoryWithdraw;
